import React from 'react'
import { Link } from 'react-router-dom'
import Paginate from 'components/paginate'
import { Search, Select, Input, InputFile, Switch } from 'components/common'
import { SimpleBanner } from './banner'
import user, {User} from './user'


const activity_types = {
	'S': "/private/media.510191266/images/servicos.png",
	'C': "/private/media.510191266/images/comercio.png",
	'I': "/private/media.510191266/images/industria.png",
	getImage: type => type && activity_types.hasOwnProperty(type)
		? <img src={activity_types[type]} alt="" />
		: null,
	pushImage: (type, list) => {
		if (!type || !activity_types.hasOwnProperty(type))
			return;
		list.push(<img key="a2" className="col" src={activity_types[type]} alt="" />)
	}
}
const search_types = {
	0: {field: 'search', label: __('attrs_search_all'), placeholder: __('users_search_placeholder')},
	//1: {field: 'postal_descrition', label: __('attrs_postal_description_long')},
	2: {field: 'cae', label: "NACE/CAE"}
}

const adminMemberEditor = (member, callback, img_name = 'logo') => {
	let file = null;
	mbox.modal(
		<div className="content">
			<InputFile type='image' onChange={e => file = e.currentTarget.files[0]} />
			<div className="form-group" />
			<div className="form-group">
				<label htmlFor="spotlight">{__('attrs_highlight')}</label>
				<Switch model={member} name="spotlight" />
			</div>

			{memberField(member, 'socials_aboutus', 'about_us')}
			{memberField(member, 'companies_foundation_date', 'birth')}
			{memberField(member, 'attrs_employees_nr', 'employees_nr')}
			{memberField(member, 'companies_social_capital', 'social_capital')}
			{memberField(member, 'companies_sales_volume', 'sales_volume')}
			{memberField(member, 'socials_headoffice', 'headoffice')}
			{memberField(member, 'socials_banks', 'banks')}
			{memberField(member, 'attrs_webinfo', 'more_info')}

		</div>, {
			title: member.name,
			buttons: [
				{
					type: 'primary',
					text: __('buttons_apply'),
					icon: 'check',
					onClick: () => {
						User.submitImage(file, img_name,
							response => {
								if (response && response.file) {
									member.spotlight_img = response.file;
								}
								callback();
								mbox.dismiss();
							},
							member.id, {
								spotlight: member.spotlight,
								about_us: member.about_us,
								birth: member.birth,
								employees_nr: member.employees_nr,
								social_capital: member.social_capital,
								sales_volume: member.sales_volume,
								headoffice: member.headoffice,
								banks: member.banks,
								more_info: member.more_info,
							}
						);
					}
				},
				'cancel'
			]
		}
	);
}


const memberField = (value, label, as_html = false, hr = true) => {
	if (typeof as_html === 'string') {
		return (
			<div>
				<label>{__(label)}:</label>
				<Input model={value} name={as_html} />
			</div>
		);
	}
	if (!value) {
		return null
	}
	return (
		<div>
			{hr ? <hr/> : null}
			<label>{__(label)}:</label>
			{as_html
				? <div dangerouslySetInnerHTML={{__html: value}} />
				: React.createElement(hr && typeof hr === 'string' ? hr : 'p', null, value)}
		</div>
	)
}

const memberContent = member =>
	<div className="member-info">
		{memberField(member.address, 'attrs_address', true, false)}
		{memberField(member.about_us, 'socials_aboutus')}
		{memberField(member.birth, 'companies_foundation_date', false, 'span')}
		{memberField(member.employees_nr, 'attrs_employees_nr', false, 'span')}
		{memberField(member.social_capital, 'companies_social_capital', false, 'span')}
		{memberField(member.sales_volume, 'companies_sales_volume', false, 'span')}
		{memberField(member.headoffice, 'socials_headoffice', false, 'span')}
		{memberField(member.banks, 'socials_banks', false, 'span')}
		{memberField(
				<tbody>
					<tr><td><em className="la la-phone" /></td><td><span>{member.phone1}</span></td></tr>
					<tr><td><em className="la la-fax" /></td><td><span>{member.fax || '-'}</span></td></tr>
					<tr><td><em className="la la-at" /></td><td><a href={'mailto:' + member.email1}>{member.email1}</a></td></tr>
					<tr><td><em className="la la-link" /></td><td><a href={member.site}>{member.site}</a></td></tr>
				</tbody>, 'attrs_contacts', false, 'table')}
		{memberField(member.activity, 'attrs_activity')}
		{memberField(member.more_info, 'attrs_webinfo')}
	</div>

class Member extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			mouseIn: false
		}
	}

	/*
	onMouseEnter() {
		this.setState({mouseIn: true});
	}

	onMouseLeave() {
		this.setState({mouseIn: false});
	}

	onFollow() {
		const {member} = this.props;
		member.following = member.following == 1 ? 0 : 1;
		http.post(
			'/home/follow.json', {
				uid: member.id,
				follow: member.following
			}, response => {
				this.forceUpdate();
				if (response.user) {
					hp.store.followers.unshift(response.user);
				}
				else {
					hp.store.followers.delete(member.id);
				}
			}
		);
	}
	*/

	onViewDetails(member) {
		const is_my_profile = user.canEditProfile(member.id);
		const is_following = !is_my_profile && hp.store.followers.get(member.id) != null;
		//const profile = user.get(member.id).profile;
		const style = {backgroundImage: "url(" + member.cover + ")"};
		const buttons = [{
			type: 'primary',
			text: __('buttons_view_profile'),
			icon: 'user',
			align: 'left',
			onClick: () => {
				mbox.dismiss();
				this.props.history.push('/home/profile/' + member.id);
			}
		}];
		if (!is_my_profile) {
			buttons.push({
				type: is_following ? 'success' : 'light',
				text: __('users_follow'),
				icon: is_following ? 'check-double' : 'check',
				align: 'left'
			});
		}
		buttons.push('close');

		mbox.modal(
			<div className="content member profile" style={style}>
				<div className="photo" onClick={() => window.open(member.site, '_blank')}>
					{this.getLogo()}
				</div>
				{memberContent(member)}
			</div>,
			{
				parent: 'member-modal',
				title: member.name,
				buttons: buttons
			}
		);
	}

	getLogo() {
		const {member} = this.props;

		//if (member.member_type == 0 && member.spotlight == 0) {
		//	return null;
		//}
		//if (member.img) {
		if ((member.member_type != 0 || member.spotlight != 0) && member.img) {
			return <img src={member.img} alt="" />
		}
		const img1 = activity_types.getImage(member.activity_type_1)
		const img2 = activity_types.getImage(member.activity_type_2)

		if (img1 || img2) {
			return (
				<table>
					<tbody>
						<tr>
							<td>{img1 || img2}</td>
							{img1 && img2 ? <td>{img2}</td> : null}
						</tr>
					</tbody>
				</table>
			);
		}
		return null;
	}

	render() {
		const {member} = this.props;
		const logo_img = this.getLogo();
		const logo_cls = classNames('photo', member.img ? null : 'none');
		const logo =
			<Link to={'/home/profile/' + member.id} className={logo_cls}>
				{logo_img}
			</Link>
		/*
		member.spotlight == 1
			?	<div className="member-content">
					<div className={logo_cls} onClick={this.onViewDetails.bind(this, member)}>
						{logo_img}
					</div>
					<em className="la la-mouse-pointer float-right symbol" />
				</div>
			:	<Link to={'/home/profile/' + member.id} className={logo_cls}>
					{logo_img}
				</Link>
		*/

		//const {mouseIn} = this.state;
		return (
			<div className="member" key={member.id}>
				{logo}
				{hp.store.adm
				 ?	<div className="btn-group btn-group-sm float-right">
						<button className="btn btn-default" onClick={() => adminMemberEditor(member, () => this.forceUpdate())}>
							<em className="la la-pencil" />
						</button>
					</div>
				:	null}
				{member.spotlight == 1
				 ?	<div className="d-none d-block d-md-none pointer">
						<em className={classNames("show-details la", member.show_details == 1 ? "la-angle-up" : "la-angle-down")} onClick={() => {
							member.show_details = member.show_details == 1 ? 0 : 1;
							this.forceUpdate();
						}} />
					</div>
				:	null}
				{member.show_details
					? memberContent(member)
					: <div className="info">
						{member.name}
					  </div>}
			</div>
		);
		/*
		return (
			<div className="member" key={member.uid}>
				<div className="photo" onMouseEnter={this.onMouseEnter.bind(this)} onMouseLeave={this.onMouseLeave.bind(this)}>
					{mouseIn && member.id != user.main.uid
						? <div className="actions">
							<div className="form-group form-check">
								<label className="form-check-label" onClick={this.onFollow.bind(this)}>
									<em className={"la la-" + (member.following == 1 ? 'check-circle' : 'circle')} />
									<span>{__('users_follow')}</span>
								</label>
							</div>
						   </div>
						: img
					}
				</div>
				<div className="info">
					{member.name}
				</div>
			</div>
		);
		*/
	}
}

export default class Members extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			url: "/home/getMembers.json",
			page_count: 24,
			f_type: '',
			f_what: 0,
			f_term: ''
		};
	}

	filter(name, value) {
		this.state[name] = value;
		this.setState({
			url: "/home/getMembers.json".urlify({
				type: this.state.f_type || '',
				what: this.state.f_what,
				term: this.state.f_term
			})
		});
	}

	render() {
		const members = {premium: [], partner: []};

		['premium', 'partner'].forEach(type => {
			const mlist = members[type];
			let group = [];
			let length = hp.store.members[type].length - 1;

			hp.store.members[type].forEach((member, i) => {
				group.push(
					<div key={i} className="col ml-2 mb-2 member img-thumbnail">
						<Link key={i} to={'/home/profile/' + member.id}>
							<img src={member.spotlight_img || member.img} className="img-fluid" alt={member.name}/>
						</Link>
						{hp.store.adm
						 ?	<div className="btn-group btn-group-sm float-right">
								<button className="btn btn-default" onClick={() => adminMemberEditor(member, () => this.forceUpdate(), 'spotlight_img')}>
									<em className="la la-pencil" />
								</button>
							</div>
						 :	null}
					</div>
				);
				if (i % 2 == 1 || i == length) {
					mlist.push( <div key={i} className="row no-gutters">{group}</div> );
					group = [];
				}
			});
		})
		return (
			<div className="members">
				<SimpleBanner title={__('socials_partner_directory')} />
				<div className="container-fluid">
					<div className="row mt-4">
						<div className="col-sm-12 col-md-12">
							<div className="row">
								<div className="col-sm filter">
									<button className={classNames("btn", !this.state.f_type ? "btn-success" : "btn-outline-secondary")} onClick={this.filter.bind(this, 'f_type', null)}>
										{__('attrs_all')}
									</button>
									<button className={classNames("btn", this.state.f_type == 9 ? "btn-success" : "btn-outline-secondary")} onClick={this.filter.bind(this, 'f_type', 9)}>
										{__('socials_premium')}
									</button>
									<button className={classNames("btn", this.state.f_type == 7 ? "btn-success" : "btn-outline-secondary")} onClick={this.filter.bind(this, 'f_type', 7)}>
										{__('socials_partner')}
									</button>
									<button className={classNames("btn", this.state.f_type == 1 ? "btn-success" : "btn-outline-secondary")} onClick={this.filter.bind(this, 'f_type', 1)}>
										{__('homes_name')}
									</button>
								</div>
								<div className="col-sm">
									<div className="float-right">
										<div className="input-group input-group-sm mb-3">
											<div className="input-group-prepend">
												<button className="btn btn-secondary dropdown-toggle" data-toggle="dropdown">{search_types[this.state.f_what].label}</button>
												<div className="dropdown-menu">
													{Object.keys(search_types).map(t =>
														<a key={t} className={classNames("dropdown-item", t == this.state.f_what ? "active" : null)} href="#" onClick={() => this.setState({f_what: t})}>
															{search_types[t].label}
														</a>
													)}
												</div>
											</div>
											{this.state.f_what != 2
												? <Search
													value={this.state.f_term}
													doSearch={value => this.filter('f_term', value)}
													placeholder={search_types[this.state.f_what].placeholder}
												  />
												: <Select
													classNameControl="prompt"
													url="/users/get_cae_nace.json"
													placeholder={search_types[this.state.f_what].label}
													onChange={option => this.filter('f_term', option.id)}
												  />
											}
											{this.state.f_term
											 ?	<div className="input-group-append" title={__('searches_reset')}>
													<button className="btn" onClick={() => this.filter('f_term', '')}><em className="la la-times" /></button>
												</div>
											 :	null}
										</div>
									</div>
								</div>
							</div>
							<div className="row justify-content-center">
								<div id="loader" className="col-12" />
							</div>
							<div className="row justify-content-center">
								<Paginate
									//items={this.state.members}
									url={this.state.url}
									classNameEl="col-sm-6 col-lg-2 col-md-4 mb-4"
									itemsPerPage={this.state.page_count}
									renderItem={ member => <Member member={member} history={this.props.history} /> }
									paginationContainer={page_nav =>
										<div key="pc" className="col-sm-12 pagination-container">
											{page_nav}
										</div>
									}
								/>
							</div>
						</div>
						<div id="member-modal" />
						{/*
						<div className="col-md-2 highlight-news">
							<h6>{__('socials_premium')}</h6>
							{members.premium}
							<h6 className="next">{__('socials_partner')}</h6>
							{members.partner}
						</div>
						*/}
					</div>
				</div>
			</div>
		);
	}
}
